import { SizingMethodApi } from '@voladeum/client';
import { v4 as uuidv4 } from 'uuid';

import { SizingMethod } from './types';

export const normalizeSizingMethods = (data: SizingMethodApi[]): SizingMethod[] =>
  data.map((d) => normalizeSizingMethod(d));

export const normalizeSizingMethod = (row: SizingMethodApi): SizingMethod => {
  return { ...row, uuid: uuidv4() };
};
